'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Editor = require('./Editor');

var _Editor2 = _interopRequireDefault(_Editor);

var _Toolbox = require('./Toolbox');

var _Toolbox2 = _interopRequireDefault(_Toolbox);

var _Email = require('./Email');

var _Email2 = _interopRequireDefault(_Email);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Editor: _Editor2.default,
  Toolbox: _Toolbox2.default,
  Email: _Email2.default
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/index.js
// module id = 1491
// module chunks = 0